import { forwardRef } from "react";
function SvgNoContentReturned({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={240}
      height={240}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#DEECFF"
        d="M14.528 139.452c-7.712 30.767 5.419 52.859 33.705 59.541 28.286 6.681 52.489-6.629 85.092-16.579 30.981-9.455 76.83 13.518 91.432-18.177 8.428-18.293-17.424-30.198-24.85-58.117-7.427-27.919-9.997-58.971-57.128-64.384-47.13-5.413-46.559 37.035-72.837 47.576-26.28 10.54-47.702 19.372-55.414 50.14Z"
      />
      <path
        fill="#fff"
        d="M172.642 74.543a4.236 4.236 0 1 1-6.082 5.9 4.236 4.236 0 0 1 6.082-5.9Z"
      />
      <path
        fill="#80B5FF"
        d="M219.826 102.904a1.319 1.319 0 1 1-1.894 1.836 1.319 1.319 0 0 1 1.894-1.836ZM34.828 168.428a3.96 3.96 0 1 1-5.684 5.513 3.96 3.96 0 0 1 5.684-5.513Z"
        opacity={0.5}
      />
      <path
        fill="#fff"
        d="M166.425 85.308a1.319 1.319 0 1 1-1.892 1.838 1.319 1.319 0 0 1 1.892-1.838ZM206.32 58.916a1.319 1.319 0 1 1-1.892 1.837 1.319 1.319 0 0 1 1.892-1.837ZM206.32 117.033a1.32 1.32 0 1 1-1.893 1.838 1.32 1.32 0 0 1 1.893-1.838ZM125.256 64.43a2.638 2.638 0 1 1-3.788 3.675 2.639 2.639 0 0 1 3.788-3.675ZM239.255 184.353a2.637 2.637 0 0 1-.057 3.731 2.638 2.638 0 1 1 .057-3.731Z"
      />
      <path
        fill="#fff"
        d="m18.142 125.619 3.834 4.9a.977.977 0 0 0 .84.37l6.123-.451a.99.99 0 0 1 .916.497 1.025 1.025 0 0 1-.023 1.06l-3.377 5.238a1.046 1.046 0 0 0-.09.934l2.317 5.813a1.02 1.02 0 0 1-.175 1.046.964.964 0 0 1-.996.301l-5.919-1.664a.973.973 0 0 0-.898.204l-4.652 4.041a.967.967 0 0 1-1.028.156.985.985 0 0 1-.418-.351 1.018 1.018 0 0 1-.172-.524l-.283-6.269a1.025 1.025 0 0 0-.462-.805l-5.215-3.311a.999.999 0 0 1-.363-.409 1.023 1.023 0 0 1 .102-1.056.99.99 0 0 1 .434-.328l5.74-2.216a.997.997 0 0 0 .61-.698l1.47-6.092c.048-.174.14-.332.27-.456a.971.971 0 0 1 1.416.07ZM170.104 111.41l2.453 3.015a.637.637 0 0 0 .538.228l3.919-.277a.636.636 0 0 1 .586.305.606.606 0 0 1-.015.653l-2.161 3.223a.633.633 0 0 0-.057.575l1.482 3.577a.611.611 0 0 1-.404.826.632.632 0 0 1-.345.003l-3.788-1.024a.648.648 0 0 0-.575.126l-2.977 2.487a.634.634 0 0 1-.659.096.628.628 0 0 1-.377-.539l-.181-3.858a.615.615 0 0 0-.296-.495l-3.337-2.038a.606.606 0 0 1-.167-.901.623.623 0 0 1 .278-.202l3.673-1.364a.625.625 0 0 0 .39-.43l.941-3.748a.616.616 0 0 1 .467-.435.632.632 0 0 1 .612.197ZM83.02 187.949l2.453 3.015a.632.632 0 0 0 .537.228l3.92-.277a.637.637 0 0 1 .586.305.614.614 0 0 1-.016.653l-2.16 3.223a.63.63 0 0 0-.058.575l1.483 3.577a.608.608 0 0 1-.112.644.635.635 0 0 1-.638.185l-3.788-1.024a.642.642 0 0 0-.575.126l-2.977 2.487a.64.64 0 0 1-.658.096.622.622 0 0 1-.377-.539l-.182-3.858a.61.61 0 0 0-.295-.495l-3.338-2.038a.61.61 0 0 1-.167-.901.62.62 0 0 1 .278-.202l3.674-1.364a.628.628 0 0 0 .39-.43l.94-3.748a.62.62 0 0 1 .468-.435.63.63 0 0 1 .611.197ZM220.723 140.908l-1.614 2.657a.5.5 0 0 0-.074.226.51.51 0 0 0 .034.236l1.121 2.913a.56.56 0 0 1-.105.505.504.504 0 0 1-.209.148.47.47 0 0 1-.249.022l-2.846-.819a.463.463 0 0 0-.225-.002.493.493 0 0 0-.204.103l-2.247 2.036a.478.478 0 0 1-.681-.115.555.555 0 0 1-.097-.247l-.149-3.14a.53.53 0 0 0-.065-.232.479.479 0 0 0-.159-.172l-2.492-1.653a.494.494 0 0 1-.178-.203.523.523 0 0 1 .047-.531.467.467 0 0 1 .21-.164l2.756-1.116a.51.51 0 0 0 .289-.356l.698-3.056a.544.544 0 0 1 .139-.223.49.49 0 0 1 .223-.121.465.465 0 0 1 .251.009.492.492 0 0 1 .214.138l1.849 2.45c.048.065.11.115.18.148a.425.425 0 0 0 .224.038l2.946-.234a.45.45 0 0 1 .239.063.49.49 0 0 1 .176.185.528.528 0 0 1-.002.507Z"
        opacity={0.8}
      />
      <path
        fill="#B3D3FF"
        d="m211.439 179.653-1.615 2.657a.512.512 0 0 0-.04.462l1.121 2.913a.56.56 0 0 1-.105.504.473.473 0 0 1-.458.171l-2.846-.819a.484.484 0 0 0-.428.101l-2.248 2.036a.472.472 0 0 1-.483.05.498.498 0 0 1-.197-.165.544.544 0 0 1-.097-.247l-.15-3.141a.517.517 0 0 0-.224-.403l-2.492-1.653a.494.494 0 0 1-.178-.203.523.523 0 0 1 .047-.532.474.474 0 0 1 .211-.163l2.756-1.117a.493.493 0 0 0 .183-.142.552.552 0 0 0 .106-.214l.698-3.055a.524.524 0 0 1 .139-.223.472.472 0 0 1 .473-.112.495.495 0 0 1 .215.138l1.849 2.45a.447.447 0 0 0 .404.186l2.945-.234a.448.448 0 0 1 .239.063.51.51 0 0 1 .24.438.53.53 0 0 1-.065.254Z"
        opacity={0.8}
      />
      <path
        fill="#1D1D1D"
        d="M59.728 22.074s-19.476-2.75-20.926 42.865c-.727 8.688 0 12.746 0 12.746l12.725-.867s2.045-55.468 8.2-54.744Z"
      />
      <path
        fill="#B3D3FF"
        d="M68.804 54.43s3.7 1.16 5.81 4.058c2.114 2.899 2.443 6.95 2.539 9.023.095 2.072 0 37.863 0 37.863l-6.273 1.757-2.076-52.701Z"
      />
      <path
        fill="#106FF3"
        d="M76.492 204.838s10.307 6.922 12.787 7.305c-1.125 2.145-3.938 2.401-3.938 2.401s-6.343-1.814-7.954-2.12c-1.611-.307-7.315.715-7.059-.511.256-1.226 1.33-7.407 1.33-7.407l4.834.332ZM52.563 205.426s10.307 6.922 12.788 7.305c-1.126 2.145-3.939 2.401-3.939 2.401s-6.343-1.814-7.954-2.12c-1.611-.307-7.314.715-7.059-.511.256-1.226 1.33-7.407 1.33-7.407l4.834.332Z"
      />
      <path
        fill="#0052C4"
        d="M73.552 99.1s9.513 54.887 8.925 56.701c-.588 1.839-5.575 49.319-5.575 49.319H71.71s-7.297-45.948-2.847-50.086c-3.555-11.518-15.26-25.055-14.799-36.472.46-11.416 11.968-20.969 11.968-20.969l7.52 1.507Z"
      />
      <path
        fill="#0052C4"
        d="m62.846 99.1 3.75 9.935s-11.55 82.394-13.52 96.953h-6.163s-3.76-47.021.128-53.431c-1.433-14.712-13.658-41.683 1.585-53.431 8.312-3.5 14.22-.026 14.22-.026Z"
      />
      <path
        fill="#1D1D1D"
        d="M63.011 55.088s2.88.672 4.352.967c1.47.294 5.735 6.968 6.736 9.67 1.001 2.703 3.118 5.794 1.059 10.555-2.062 4.76 0 9.753 0 15.555s1.039 10.463 1.214 13.109c.175 2.647-27.667 3.073-33.138-1.746 0 0 5.498-8.228 6.205-9.403.706-1.177.12-7.583-.527-9.229-.648-1.644-4.957-15.638-4.957-15.638s-3.526-10.747-.341-13.216c2.767-2.146 10.304-2.91 11.657-3.38 1.354-.473 4.972 2.346 7.74 2.756Z"
        opacity={0.2}
      />
      <path
        fill="#B3D3FF"
        d="M62.362 52.066s4.971 2.069 6.442 2.364c1.471.294 6.445 7.628 7.446 10.33 1.001 2.703 0 6.759-2.06 11.52-2.061 4.76-.119 6.348-1.058 11.11-.943 4.76 2.097 14.908 2.273 17.554.175 2.647-27.667 3.073-33.139-1.746 0 0 5.499-8.228 6.206-9.403.706-1.177.12-7.583-.528-9.229-.648-1.644-4.957-15.638-4.957-15.638s-3.525-10.747-.34-13.216c2.766-2.146 10.303-2.91 11.657-3.38 1.354-.473 5.29-.676 8.058-.266Z"
      />
      <path
        fill="#A6735B"
        d="M64.38 47.183s-.114 1.062-.253 2.528c-.059.65-.126 1.38-.185 2.131-.172 2.14-.314 4.453-.231 5.63 0 0-4.403 4.408-9.41-5.141 0 0 2.107-3.938.52-9.302-1.585-5.362 9.559 4.154 9.559 4.154Z"
      />
      <path
        fill="#A6735B"
        d="M65.884 22.796s9.873 3.096 4.515 20.11c-5.36 17.015-18.844-1.97-17.433-12.338 1.41-10.365 12.918-7.772 12.918-7.772Z"
      />
      <path
        fill="#1D1D1D"
        d="M71.404 32.722s-4.906 4.807-13.115 5.407c0 0-3.155 3.695-3.4 5.145 0 0-8.588-14.326 1.682-19.941 10.882-5.95 18.144 6.31 14.833 9.389Z"
      />
      <path
        fill="#A6735B"
        d="M58.227 38.032c-.063-1.237-.827-4.055-2.67-3.267-1.84.788.114 6.528 1.337 6.175 0 0 1.483.024 1.333-2.908Z"
      />
      <path
        fill="#1D1D1D"
        d="M64.128 49.71c-.059.652-.126 1.381-.185 2.132h-.002c-5.708-2.812-6.582-6.872-6.608-6.996 4.068 5.248 6.795 4.865 6.795 4.865Z"
        opacity={0.3}
      />
      <path
        fill="#A6735B"
        d="M53.573 52.51s5.53 8.994 9.918 8.886c4.385-.104 1.393-8.316 1.393-8.316s-3.367-2.688-11.31-.57Z"
      />
      <path
        fill="#0052C4"
        d="M114.722 98.937H210l-18.734 13.917H95.988l18.734-13.917Z"
      />
      <path fill="#0052C4" d="M149.077 112.626h42.549V219h-42.549z" />
      <path
        fill="#106FF3"
        d="M78.86 103.754H36.572l17.129 9.1h42.286l-17.129-9.1Z"
      />
      <path fill="#106FF3" d="M62.044 112.626h87.033V219H62.044z" />
      <path
        fill="#80B5FF"
        d="M53.701 112.854h95.278l-18.734 35.328H34.967L53.7 112.854ZM166.108 125.165h42.286l-17.128-12.311h-42.287l17.129 12.311Z"
      />
      <path
        fill="#A6735B"
        d="M55.946 108.024c-1.645-1.151-2.972-3.42-3.43-4.41l-1.8-.708 2.356-3.395 1.737 1.164c.401.248 1.353.856 1.955 1.309.753.566 3.538 3.613 4.679 4.812 1.14 1.199 1.048 1.882 1.056 2.696.008.813-.914 1.5-1.542 1.764-.502.21-1.057-.647-1.272-1.101-.561-.231-2.094-.98-3.739-2.131Z"
      />
      <path
        fill="#1D1D1D"
        d="M39.802 63.308c1.747-4.192 3.98-6.61 5.319-5.8 6.026 3.644 1.853 10.437 1.37 13.821-.346 2.418 0 7.935 0 7.935l-2.337-4.352-.484 11.604 4.835 3.869v-.967l9.67 10.637-5.318 3.385-17.328-15.686c-1.235-1.2-.16-15.941.604-19.092.687-3.619 1.922-1.163 3.669-5.354Z"
        opacity={0.2}
      />
      <path
        fill="#B3D3FF"
        d="M39.566 58.475c1.747-4.191 6.219-4.28 7.558-3.471 6.027 3.644-1.117 13.908-1.6 17.292-.346 2.418-.974 12.572-.974 12.572l12.659 16.154-5.319 3.385-17.328-15.685c-1.235-1.2-.16-15.942.605-19.093.686-3.618 2.651-6.962 4.399-11.154Z"
      />
      <path
        stroke="#80B5FF"
        strokeDasharray="2 2"
        d="M127 113c3.667-5.167 8.2-16.2-3-19-14-3.5-22-10-21-23.5s14.5-18.5 24-19S154.5 54 155 67s-23 15-25.5-5c-2-16 16.167-24.667 25.5-27"
      />
      <ellipse
        fill="#1D1D1D"
        rx={1.354}
        ry={0.862}
        transform="matrix(-1 0 0 1 154.859 35.339)"
      />
      <ellipse
        fill="#1D1D1D"
        rx={0.492}
        ry={0.615}
        transform="matrix(-1 0 0 1 156.46 35.339)"
      />
      <path
        fill="#1D1D1D"
        d="M154.491 34.182c0 .543.167.787.633.787.466 0 .844-.44.844-.984s-.211-.985-.211-.985-1.266.638-1.266 1.182Z"
      />
      <path
        fill="#1D1D1D"
        d="M154.946 34.103c.195.507.127.795-.308.962-.435.168-.946-.108-1.141-.615-.196-.508-.158-.995-.158-.995s1.411.14 1.607.648Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgNoContentReturned);
export default ForwardRef;
